import dayjs from 'dayjs';

import type { Dayjs } from 'dayjs';

export type DatePresetId =
  | '15min'
  | '30min'
  | '1hour'
  | 'today'
  | 'tomorrow'
  | 'end_of_week'
  | 'next_week'
  | 'next_month'
  | 'next_year';

export interface DatePreset {
  readonly id: DatePresetId;
  readonly label: string;
  readonly chipLabel: string;
  readonly isAllDay: boolean;
  getDate(): Dayjs;
  getStartTime(): string | null;
  getEndTime(): string | null;
}

const pad = (n: number) => String(n).padStart(2, '0');
const fmtTime = (d: Dayjs): string => `${pad(d.hour())}:${pad(d.minute())}`;

// (7 - dow) % 7 gives days-to-Sunday for any day-of-week (Sun=0..Sat=6); Sunday itself → 0
const getEndOfCalendarWeek = (): Dayjs => {
  const today = dayjs();
  const daysToSunday = (7 - today.day()) % 7;
  return today.add(daysToSunday, 'day').startOf('day');
};

export const DATE_PRESETS: readonly DatePreset[] = [
  {
    id: '15min',
    label: 'Через 15 минут',
    chipLabel: '~ 15 мин',
    isAllDay: false,
    getDate: () => dayjs().startOf('day'),
    getStartTime: () => fmtTime(dayjs().add(15, 'minute')),
    getEndTime: () => fmtTime(dayjs().add(75, 'minute')),
  },
  {
    id: '30min',
    label: 'Через 30 минут',
    chipLabel: '~ 30 мин',
    isAllDay: false,
    getDate: () => dayjs().startOf('day'),
    getStartTime: () => fmtTime(dayjs().add(30, 'minute')),
    getEndTime: () => fmtTime(dayjs().add(90, 'minute')),
  },
  {
    id: '1hour',
    label: 'Через час',
    chipLabel: '~ 1 ч',
    isAllDay: false,
    getDate: () => dayjs().startOf('day'),
    getStartTime: () => fmtTime(dayjs().add(1, 'hour')),
    getEndTime: () => fmtTime(dayjs().add(2, 'hour')),
  },
  {
    id: 'today',
    label: 'Сегодня',
    chipLabel: 'Сегодня',
    isAllDay: true,
    getDate: () => dayjs().startOf('day'),
    getStartTime: () => null,
    getEndTime: () => null,
  },
  {
    id: 'tomorrow',
    label: 'Завтра',
    chipLabel: 'Завтра',
    isAllDay: true,
    getDate: () => dayjs().add(1, 'day').startOf('day'),
    getStartTime: () => null,
    getEndTime: () => null,
  },
  {
    id: 'end_of_week',
    label: 'До конца недели',
    chipLabel: 'До воскресенья',
    isAllDay: true,
    getDate: getEndOfCalendarWeek,
    getStartTime: () => null,
    getEndTime: () => null,
  },
  {
    id: 'next_week',
    label: 'Через неделю',
    chipLabel: 'Через неделю',
    isAllDay: true,
    getDate: () => dayjs().add(1, 'week').startOf('day'),
    getStartTime: () => null,
    getEndTime: () => null,
  },
  {
    id: 'next_month',
    label: 'Через месяц',
    chipLabel: 'Через месяц',
    isAllDay: true,
    getDate: () => dayjs().add(1, 'month').startOf('day'),
    getStartTime: () => null,
    getEndTime: () => null,
  },
  {
    id: 'next_year',
    label: 'Через год',
    chipLabel: 'Через год',
    isAllDay: true,
    getDate: () => dayjs().add(1, 'year').startOf('day'),
    getStartTime: () => null,
    getEndTime: () => null,
  },
];
